import React, { useRef, useState, useId } from "react";
import './MyAccountProjects.scss';
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function MyAccountProjects({ ProjectList }) {

    useEffect(() => {
        // window.scrollBy({
        //     top: 330,
        //     behavior: 'smooth'
        //   });
    }, []);


    return (
        <div className="MyAccountProjects">
            <div className="MyAccountProjectsHeader">
                <div className="MyAccountProjectsHeaderLeft">
                    <h1>My Projects</h1>
                    <h2>Call or message them to discuss quotes.</h2>
                </div>
                <img src={require(`../../../Images/document.png`)} alt="Chimney Cleaning" />
            </div>
            <div className="MyAccountProjectsLlist">
                {ProjectList.length ?
                    <div className="MyAccountProjectsLlistProjectsMain">
                        {
                            ProjectList.map((A, index) => {
                                return <div key={index} className="MyAccountProjectsLlistProjectsBox">
                                    <div className="MyAccountProjectsLlistProjectsBoxLeft">
                                        <h5>New Project</h5>
                                        <h1>{A.Service}</h1>
                                        {/* <h1>{A.Service} <span>/ {A.TypeOfPropery} </span></h1> */}
                                        <h3>Services reqested: {A.TypeOfservices.map((A2, index2) => <span key={index2}>{A2}{index2 == ProjectList[index].TypeOfservices.length - 1 ? "." : ","}</span>)}</h3>
                                    </div>
                                    <div className="MyAccountProjectsLlistProjectsBoxRight">
                                        <h5>Pending</h5>
                                        <span>
                                            <h2><img src={require(`../../../Images/calendar.png`)} /> {A.DateForProject} Between {A.WindowTime}</h2>
                                            <h2><img src={require(`../../../Images/location.png`)} /> {A.Address}{A.Apt ? " Apt " + A.Apt : ''}, {A.City} {A.ZipCode}</h2>
                                        </span>
                                    </div>
                                </div>
                            })}
                    </div>
                    :
                    <div className="MyAccountProjectsLlistProjectsNoProject">
                        <h1>You don't have any projects yet</h1>
                        <a href="/start-project">Click to Create Project!</a>
                    </div>
                }
            </div>
        </div >
    )
}

